module.exports = __webpack_public_path__ + "static/default-career-changers-desktop.f31c1fd5.webp";